import { useSetRecoilState } from 'recoil';
import { useMutation } from '@apollo/client';
import {
  ADD_OR_UPDATE_SOLICITATION_PERIOD,
  DELETE_SOLICITATION_PERIOD,
} from '../../queries';
import solicitationNotifications from '../../utils/solicitation-notification-helpers';
import { pageErrorNotifications } from '../../../../utilities/error-handling';

export default function useReopenPeriod(refetchSolicitation) {
  const setSolicitationNotification = useSetRecoilState(
    solicitationNotifications,
  );

  const [addSolicitationPeriod, { loading: addPeriodLoading }] = useMutation(
    ADD_OR_UPDATE_SOLICITATION_PERIOD,
    {
      onError: (requestError) => {
        setSolicitationNotification([
          ...pageErrorNotifications(requestError, {
            id: 'ADD_OR_UPDATE_SOLICITATION_PERIOD_ERROR',
            message: requestError.message,
            type: 'error',
            closeable: false,
            showInModal: false,
          }),
        ]);
      },
      onCompleted: () => {
        setSolicitationNotification([
          {
            id: 'ADD_OR_UPDATE_SOLICITATION_PERIOD',
            message: 'Solicitation period added successfully.',
            type: 'success',
            closeable: true,
            showInModal: false,
          },
        ]);
        if (refetchSolicitation) {
          refetchSolicitation();
        }
      },
    },
  );

  const [deleteSolicitationPeriod] = useMutation(DELETE_SOLICITATION_PERIOD, {
    onError: (requestError) => {
      setSolicitationNotification([
        ...pageErrorNotifications(requestError, {
          id: 'DELETE_SOLICITATION_PERIOD_ERROR',
          message: requestError.message,
          type: 'error',
          closeable: false,
          showInModal: false,
        }),
      ]);
    },
    onCompleted: (response) => {
      setSolicitationNotification([
        {
          id: 'DELETE_SOLICITATION_PERIOD',
          message: 'Solicitation period deleted successfully.',
          type: 'success',
          closeable: true,
          showInModal: false,
        },
      ]);
      const { id } = response.deleteSolicitationPeriodById || {};
      if (id && refetchSolicitation) {
        refetchSolicitation();
      }
    },
  });

  return {
    addPeriodLoading,
    addSolicitationPeriod,
    deleteSolicitationPeriod,
  };
}
